import React from "react";
import PropTypes from 'prop-types';
import './AccountCard.css';
import './AccountCardMobile.css';
import Constants from "components/utils/constants";
import { ListItemHandler } from 'chits-data/dist';
import { Button, LinearProgress } from "@material-ui/core";
import { connect } from "react-redux";
import mapStateToProps from "reducers/actions/stateToProps";
import mapDispatchToProps from "reducers/actions/dispatchProps";
let console = Constants.consoleWrapper(false);
class AccountCard extends React.Component {

    constructor(props) {
      super(props)
      this._handlerListItem = new ListItemHandler();
    }
    
	state = {
		typeMap: [],
        activeCardId: undefined
    };
    
    componentDidMount = () => {
        this.handleGetAcctTypes();
    }

    handleGetAcctTypes = async () => {
        let typeMap = [];
        this._handlerListItem.getAcctTypes()
		.then((data) => {
            // console.log(data);
            data.forEach((type, index) => {
                typeMap[type.code] = type.name;
            });
            this.setState({ typeMap });
		})
		.catch((err) => {
			console.log('error while fetching account types:' + err.message);
        });
    }

    //TODO: Move the term calculation logic to a business engine module
    getChitInfoSection = (account) => {
        let {chit_info} = account;
        if (!chit_info) return <></>;
        let {
            // chit_amount,
            chit_tenure,
            // chit_subscribers,
            // chit_term_amount,
            // chit_term_fee,
            chit_start_on,
            chit_draw_date,
            // chit_due,
            nextTerm
        } = chit_info;
        let progress = parseInt(((nextTerm ? nextTerm - 1 : 0)/chit_tenure)*100);
        return (
            <div className="chit-progress-div">
                <label><strong>Start Date: </strong><span>{chit_start_on}</span></label><label><strong>&nbsp;&nbsp;&nbsp;Draw On: </strong><span>{Constants.nThConversion(chit_draw_date)}</span></label>
              {nextTerm && nextTerm > 0 && <>
                <br /><label>Current Term: <span>{nextTerm-1}/{chit_tenure}</span></label>
                <br /><LinearProgress value={progress} color="secondary" variant="determinate" />
              </>}
              {nextTerm === -1 && <>
                <br /><label>Term: <Button variant={"contained"} color="primary" size="small">Completed</Button></label>
                <br /><LinearProgress value={100} color="primary" variant="determinate" />
              </>}
              {!nextTerm && <>
                <br /><label>Term: <Button variant={"contained"} color="secondary" size="small">Not started</Button></label>
              </>}
            </div>
        )
    }
    
    render() {
        let _this = this;
        let _imgPath = '/assets/img/accounts/icons';
        let _accountTypes = ["CC","CHQ","DEF","FRN","SAV", "BILL", "INV", "CHIT", "SUB", "UTIL"];
        console.debug('Active account: ', this.props.wallet.current.name);
        return (
            <ul className={`cardGrid ${_this.props.zoomIn  ? 'zoomin' : ''}`}>
                {this.props.accounts.map(function (account, index) {
                    // console.debug('CARD -> account', account);
                    let icon = <img src={`${_imgPath}/DEF.png`} alt="Default Account" width={100}  />;
                    if (_accountTypes.includes(account.type)) {
                        icon = <img src={`${_imgPath}/${account.type}.png`} alt={account.type} width={100} />;
                    }
                    // console.debug('account.curr', account.curr)
                    let locale = Constants.getCurrencyLocale(account.curr);
                    // console.debug('locale', locale);

                    let bal = account.chit_info.chit_amount;
                    // console.debug('type of bal', typeof(bal))
                    let creditBal = '';
                    if (account.type === 'CC') {
                        if (account.bal <= 0) {
                            creditBal = 'credit-bal';
                            if (account.bal < 0) bal *= -1;
                        }
                    }
                    // console.debug('bal', bal);
                    bal = bal.toLocaleString(locale, { style: 'currency', currency: account.curr });
                    if (creditBal === 'credit-bal' && account.bal < 0) {
                        bal += ' CR'
                    }
                    // console.debug('bal', bal);

                    let zoomInClass = '';
                    if (_this.props.zoomIn) {
                        zoomInClass = (!account.isOwner ? 'shared-account-card' : 'owner-account-card');
                    }
                    zoomInClass += (account.status === 'ac') ? ' active-account' : ' archive-account'

                    let isActiveClass = (_this.props.wallet.current._id === account._id) ? 'active' : '';

                    return (
                        <li id={account._id} key={account._id} className={`${account.type} card ${zoomInClass} ${isActiveClass}`}
                            onClick={()=>{
                                if (_this.state.activeCardId) {
                                    window.document.getElementById(_this.state.activeCardId).classList.remove("my-active-account")
                                }
                                window.document.getElementById(account._id).classList.add("my-active-account")
                                _this.setState({ activeCardId: account._id})
                                setTimeout(()=>{
                                    _this.props.onViewTrans(account._id)
                                },500)
                            }}>
                            {icon}
                            <span className="code">{account.code}</span>
                            {!account.isOwner && 
                                <span className="shared-icon">
                                    <i className="pe-7s-users"></i>
                                </span>}
                            {_this.props.showEditIcon && 
                                <span className="action-edit" onClick={()=>_this.props.onEdit(account._id)}>
                                    <i className="pe-7s-pen" style={{fontSize: 34}}></i>
                                    <span>Edit</span>
                                </span>}
                            {_this.props.showViewTransIcon && account.status === 'ac' && 
                                <span className="action-view" onClick={()=>_this.props.onViewTrans(account._id)}>
                                    <i className="pe-7s-cash" style={{fontSize: 50}}></i>
                                    <span>Transactions</span>
                                </span>}
                            <span className="name">{Constants.getAccountName(account)}</span>
                            {/* <span className="type">{_this.state.typeMap[account.type]}</span> */}
                            <span className={`bal ${creditBal}`}>{bal}</span>
                            {_this.getChitInfoSection(account)}
                        </li>
                    )
                })}
            </ul>
        )
    }
}

AccountCard.propTypes = {
    accounts: PropTypes.array.isRequired,
    onEdit: PropTypes.func.isRequired,
    onViewTrans: PropTypes.func.isRequired,
    onUnlock: PropTypes.func,
    showEditIcon: PropTypes.bool,
    showViewTransIcon: PropTypes.bool,
    zoomIn: PropTypes.bool
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountCard);